var render = function render(_c,_vm){return (_vm.props.url)?_c('img',{staticClass:"user__avatar",class:{'user__avatar--round': _vm.props.round},attrs:{"src":_vm.props.url}}):_c('img',{staticClass:"user__avatar",class:{'user__avatar--round': _vm.props.round},attrs:{"src":require("@/assets/images/default-user.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }